// extracted by mini-css-extract-plugin
module.exports = {"checkmark":"Checkbox_checkmark__MCE_d"};